import { Component, inject, input } from "@angular/core";
import { outputFromObservable } from "@angular/core/rxjs-interop";
import { ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { DynamicFormDirective } from "@lib/base/modules/form/dynamic-form/dynamic-form.directive";
import { DynamicFormProps, UnknownFormGroup } from "@lib/base/modules/form/dynamic-form/dynamic-form.types";
import { TreeRegistration } from "@lib/base/modules/form/dynamic-form/tree-registration.injectable";
import { filter, first, map, switchMap } from "rxjs";

@Component({
    selector: "app-dynamic-form-v2",
    styleUrl: "./dynamic-form.component.scss",
    templateUrl: "./dynamic-form.component.html",
    imports: [
        ReactiveFormsModule,
        DynamicFormDirective,
    ],
    providers: [
        TreeRegistration,
    ],
})
export class DynamicFormComponent {
    treeRegistration = inject(TreeRegistration);

    formDefinition = input.required<DynamicFormProps[]>();
    direction = input<"row" | "column">("row");

    formGroup: UnknownFormGroup = new UntypedFormGroup({});

    obs = this.treeRegistration.statusChanges.pipe(
        filter(e => e === "ready"),
        first(),
        map(() => this.formGroup),
    );

    form = outputFromObservable(this.obs);

    changes = outputFromObservable(this.obs.pipe(
        switchMap(obs => obs.valueChanges),
    ));
}
